// Canonical option lists used by both the onboarding flow and the profile
// editor. Single source of truth so the two never drift.

// "Things to avoid in products" — allergies, sensitivities, clean-beauty
// preferences, brand-specific avoids, anything else. Stored as a freetext
// text[] in user_profiles.sensitivities. We deliberately do NOT enumerate a
// closed set — the long tail is enormous (specific brands, "anything with
// 'natural' on the label") so freetext is the primary input. These are
// suggestions shown in the combobox dropdown for one-tap addition; users
// can also type anything else and add their own label.
export const COMMON_AVOIDS = [
  'Fragrance',
  'Essential oils',
  'Retinol',
  'AHAs (glycolic, lactic)',
  'BHAs (salicylic acid)',
  'Alcohol (denat.)',
  'Sulfates (SLS, SLES)',
  'Parabens',
  'Silicones',
  'Mineral oil',
  'Phenoxyethanol',
  'PEGs',
  'Formaldehyde releasers',
  'Lanolin',
  'Nuts',
  'Soy',
  'Gluten',
  'Latex',
];

// Normalise + dedupe a tag input. Trims whitespace, drops empties, dedupes
// case-insensitively while preserving the user's original casing for display.
// Caps each tag at 60 chars so a runaway paste doesn't pollute the column.
export function normaliseAvoidTags(arr) {
  if (!Array.isArray(arr)) return [];
  const seen = new Set();
  const out = [];
  for (const raw of arr) {
    if (typeof raw !== 'string') continue;
    const trimmed = raw.trim().slice(0, 60);
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out;
}

// Read a saved sensitivities array into the UI's tag list. Strips any legacy
// 'None' sentinel from older sessions (we no longer treat that as a distinct
// state — empty means empty).
export function readSensitivityTags(arr) {
  const list = Array.isArray(arr) ? arr.filter(Boolean) : [];
  return normaliseAvoidTags(list.filter(s => String(s).toLowerCase() !== 'none'));
}

// Backwards-compat re-export. Older imports referenced REACTION_OPTIONS as
// the canonical chip list — those callers can keep working while we migrate.
export const REACTION_OPTIONS = COMMON_AVOIDS;
